<template>
  <v-dialog v-model="model" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">
        {{ $t("views.wip.work_in_progress") }}
      </v-card-title>
      <v-card-text>
        <!-- {{ $t("views.wip.work_in_progress") }} -->
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('close')">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    model: Boolean,
  },
};
</script>
